// src/js/modules/phoneMask.js
import IMask from 'imask';

export function initPhoneMask() {
    const phoneInputs = document.querySelectorAll('.tel-validate');

    if (!phoneInputs.length) return;

    phoneInputs.forEach(input => {
        // Якщо маска вже застосована — пропускаємо
        if (input.dataset.maskApplied) return;

        IMask(input, {
            mask: '+{38} (000) 000-00-00',
            lazy: false,          // показує шаблон навіть коли поле порожнє
            overwrite: true,      // перезаписує символи під час набору
        });

        // Позначаємо, що маску вже додано
        input.dataset.maskApplied = 'true';
    });
}
